import * as React from "react";

function IconTrendingDown2({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-trending-down-2" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/trending-down-2"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 6h5l7 10h6" /><path d="M18 19l3 -3l-3 -3" /></svg>;
}

export default IconTrendingDown2;